/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import MFCheckbox from '../../lib/formik/Checkbox';
import { NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkAddressField,
  checkInitialApplicationStatusIsChecker,
  checkValidationBasedOnDate,
  getApplicantName,
  getDisableStatusForjointHolder,
  getNomineeRelation,
  isMinor,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useParams } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  nomineeIdTypes,
  NomineeRelations,
  USER_ROLES,
} from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../../lib/DatePickerWithTextFeild';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { useValidationOrConfigHook } from '../../utils/validationOrConfigHook';
import { nonDigitRegex } from '../../utils/regex';

type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
  otherGuardianRelationship: string | null;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  saveType: string;
  countryDropdown: string[];
};

type ValidationFlags = {
  showNomineIdType: boolean;
  removeDecimalValidationForPercentage: boolean;
};

export const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  nomineeIdType: '',
  nomineeIdTypeOther: '',
  nomineeIdNumber: '',
  nomineeEmail: '',
  nomineePhone: '',
  nomineeCountryCode: '+91',
  nomineeCountryNameAndCode: 'India: +91',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  guardianFirstName: '',
  guardianLastName: '',
  guardianDOB: null,
  nomineePan: '',
  nomineeGuardianPan: '',
  isActive: true,
  Relationship: '',
  nomineeCountry: null,
  guardianCountry: null,
  sno: 0,
  guardianRelationship: '',
  otherGuardianRelationship: '',
  firstName: '',
  lastName: '',
  guardianCountryNameAndCode: 'India: +91',
  nomineePhoneSameAsGuardian: false,
  nomineeEmailSameAsGuardian: false,
  guardianPhone: '',
  guardianEmail: '',
  guardianCountryCode: '+91',
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  saveType: 'save and proceed',
  countryDropdown: [],
};

const Nominee = ({
  nomineeName,
  index,
  values,
  nationalitiesMdmsResponse,
  address,
  shouldShowNomineeIdTypes,
}: {
  nomineeName: number;
  index: number;
  values: Values;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  address: any;
  shouldShowNomineeIdTypes: boolean;
}): JSX.Element => {
  const { dateOfBirth = '' } = values.nominees[index];
  const { setFieldValue, setValues } = useFormikContext();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  const [mobileElementWidthGuardian, setMobileElementWidthGuardian] = useState(null);
  const guardianMandatory = isMinor(dateOfBirth || '') && shouldShowNomineeIdTypes;

  useEffect(() => {
    const mobileElement = document.getElementsByName('nominees.0.nomineePhone');
    const mobileElementGuardian = document.getElementsByName('nominees.0.guardianPhone');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
    setMobileElementWidthGuardian(mobileElementGuardian[0]?.parentElement?.clientWidth as any);
  }, []);

  useEffect(() => {
    setValues({
      ...values,
      nominees: values.nominees.map((nominee, i) => {
        if (i === index) {
          return {
            ...nominee,
            guardianAddress1:
              nominee.guardianAddress1 === null
                ? checkAddressField(address?.address1)
                : nominee.guardianAddress1,
            guardianAddress2:
              nominee.guardianAddress2 === null
                ? checkAddressField(address?.address2)
                : nominee.guardianAddress2,
            guardianAddress3:
              nominee.guardianAddress3 === null
                ? checkAddressField(address?.address3)
                : nominee.guardianAddress3,
            guardianCity:
              nominee.guardianCity === null
                ? checkAddressField(address?.city)
                : nominee.guardianCity,
            guardianState:
              nominee.guardianState === null
                ? checkAddressField(address?.state)
                : nominee.guardianState,
            guardianCountry:
              nominee.guardianCountry === null
                ? checkAddressField(address?.country)
                : nominee.guardianCountry?.toUpperCase(),
            guardianPincode:
              nominee.guardianPincode === null ? address?.pincode : nominee.guardianPincode,
            guardianEmail: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.guardianEmail
              : null,
            guardianPhone: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.guardianPhone
              : null,
            nomineeEmailSameAsGuardian: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.nomineeEmailSameAsGuardian
              : newNominee.nomineeEmailSameAsGuardian,
            nomineePhoneSameAsGuardian: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.nomineePhoneSameAsGuardian
              : newNominee.nomineePhoneSameAsGuardian,
            guardianCountryNameAndCode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.guardianCountryNameAndCode
              : 'India: +91',
            guardianCountryCode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
              ? nominee.guardianCountryNameAndCode?.split(':')[1].trim()
              : '+91',
          };
        }
        return nominee;
      }),
    });
  }, [values.nominees[index].dateOfBirth]);
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.firstName`}
          label={`Nominee First Name ${nomineeName} *`}
          placeholder={`Enter Nominee First Name ${nomineeName}`}
          disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.lastName`}
          label={`Nominee Last Name ${nomineeName} *`}
          placeholder={`Enter Nominee Last Name ${nomineeName}`}
          disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Nominee Relationship *"
          items={Object.keys(NomineeRelations)
            .filter((relation) => {
              const { nominees } = values;
              const selectedRelations = nominees
                .filter(
                  (nominee, ind) =>
                    ind !== index &&
                    nominee.Relationship &&
                    nominee.isActive &&
                    [
                      NomineeRelations.mother,
                      NomineeRelations.father,
                      NomineeRelations.spouse,
                    ].includes(NomineeRelations[nominee.Relationship || ''])
                )
                .map((nominee) => nominee.Relationship);
              return !selectedRelations.includes(relation);
            })
            .map((relation) => ({
              key: NomineeRelations[relation],
              value: relation,
            }))}
          disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
        />
      </Grid>
      {values.nominees.map((nominee, idx: number) => {
        if (
          NomineeRelations[nominee?.Relationship || ''] === NomineeRelations.others &&
          idx === index
        ) {
          return (
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.nomineeRelationship`}
                label="Relationship *"
                placeholder={`Enter Nominee Relationship`}
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
          );
        }
      })}
      <Grid item xs={12} sm={6}>
        <TextDatePicker
          label={'Date of Birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of Birth'}
          disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          name={`nominees.${index}.dateOfBirth`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
          disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
        />
      </Grid>
      {shouldShowNomineeIdTypes ? (
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeEmail`}
              label={`Nominee Email`}
              placeholder="Enter Nominee Email"
              disabled={
                getDisableStatusForjointHolder(role, referenceDetail.applicant_type) ||
                (isMinor(dateOfBirth ? dateOfBirth : '') &&
                  values.nominees[index].nomineeEmailSameAsGuardian)
              }
            />
            {isMinor(dateOfBirth ? dateOfBirth : '') && (
              <MFCheckbox
                name={`nominees.${index}.nomineeEmailSameAsGuardian`}
                label="Nominee Email Same As Guardian"
                sx={{ letterSpacing: '1px' }}
                checked={values.nominees[index].nomineeEmailSameAsGuardian}
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                onChange={({ target: { checked } }) => {
                  setValues({
                    ...values,
                    nominees: values.nominees.map((nominee, i) => {
                      return i === index
                        ? {
                            ...nominee,
                            nomineeEmail: checked
                              ? nominee.guardianEmail || newNominee.guardianEmail
                              : newNominee.nomineeEmail,
                            nomineeEmailSameAsGuardian: checked,
                          }
                        : nominee;
                    }),
                  });
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineePhone`}
              label={`Nominee Phone Number`}
              placeholder={`Enter Nominee Phone Number`}
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`nominees.${index}.nomineeCountryNameAndCode`}
                  value={values.nominees[index].nomineeCountryNameAndCode}
                  disabled={
                    getDisableStatusForjointHolder(role, referenceDetail.applicant_type) ||
                    (isMinor(dateOfBirth ? dateOfBirth : '') &&
                      values.nominees[index].nomineePhoneSameAsGuardian)
                  }
                />
              }
              disabled={
                getDisableStatusForjointHolder(role, referenceDetail.applicant_type) ||
                (isMinor(dateOfBirth ? dateOfBirth : '') &&
                  values.nominees[index].nomineePhoneSameAsGuardian)
              }
            />
          </Grid>
          {isMinor(dateOfBirth ? dateOfBirth : '') && (
            <MFCheckbox
              name={`nominees.${index}.nomineePhoneSameAsGuardian`}
              label="Nominee Phone Number Same As Guardian"
              sx={{ letterSpacing: '1px' }}
              checked={values.nominees[index].nomineePhoneSameAsGuardian}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              onChange={({ target: { checked } }) => {
                setValues({
                  ...values,
                  nominees: values.nominees.map((nominee, i) => {
                    return i === index
                      ? {
                          ...nominee,
                          nomineePhone: checked
                            ? nominee.guardianPhone || newNominee.guardianPhone
                            : newNominee.nomineePhone,
                          nomineePhoneSameAsGuardian: checked,
                          nomineeCountryNameAndCode: checked
                            ? nominee.guardianCountryNameAndCode ||
                              newNominee.guardianCountryNameAndCode
                            : newNominee.nomineeCountryNameAndCode,
                        }
                      : nominee;
                  }),
                });
              }}
            />
          )}
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`nominees.${index}.nomineeIdType`}
              label={`Nominee Id Type`}
              items={Object.keys(nomineeIdTypes).map((item) => ({
                key: nomineeIdTypes[item],
                value: item,
              }))}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            />
          </Grid>
          {nomineeIdTypes?.others &&
            nomineeIdTypes[values.nominees[index].nomineeIdType || ''] ===
              nomineeIdTypes?.others && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.nomineeIdTypeOther`}
                  label="Other Document Name *"
                  placeholder="Enter Document Name"
                  disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                />
              </Grid>
            )}
          {values.nominees[index].nomineeIdType &&
            nomineeIdTypes[values.nominees[index].nomineeIdType || ''] !==
              nomineeIdTypes?.others && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.nomineeIdNumber`}
                  label="Nominee Id *"
                  placeholder="Enter Nominee Id"
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onChange={(e) => {
                    setFieldValue(
                      `nominees.${index}.nomineeIdNumber`,
                      ((e.target.value || '') as string).toUpperCase()
                    );
                  }}
                  disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                />
              </Grid>
            )}
        </>
      ) : (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineePan`}
            label={`Nominee PAN/ Aadhaar`}
            placeholder="Enter Nominee PAN/ Aadhaar"
            inputProps={{ style: { textTransform: 'uppercase' } }}
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            onChange={(e) => {
              setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
            }}
          />
        </Grid>
      )}
      {/* <---------Nominee Address-------> */}
      <>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeAddress1`}
            label={`Nominee Address Line 1 *`}
            placeholder="Enter Nominee Address Line 1"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeAddress2`}
            label={`Nominee Address Line 2 *`}
            placeholder="Enter Nominee Address Line 2"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeAddress3`}
            label={`Nominee Address Line 3 *`}
            placeholder="Enter Nominee Address Line 3"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineePincode`}
            label={`Nominee Pincode *`}
            placeholder="Enter Nominee Pincode"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeCity`}
            label={`Nominee City *`}
            placeholder="Enter Nominee City"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeState`}
            label={`Nominee State *`}
            placeholder="Enter Nominee State"
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SearchableSelect
            name={`nominees.${index}.nomineeCountry`}
            label="Nominee Country *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
      </>
      {isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianFirstName`}
              label={`Guardian First Name ${nomineeName} *`}
              placeholder={`Enter Guardian First Name ${nomineeName}`}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianLastName`}
              label={`Guardian Last Name ${nomineeName} *`}
              placeholder={`Enter Guardian Last Name ${nomineeName}`}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            />
          </Grid>
          {shouldShowNomineeIdTypes && (
            <>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.guardianEmail`}
                  label={`Guardian Email`}
                  placeholder={`Enter Guardian Email`}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee, _nominee_Ind) => {
                        return _nominee_Ind === index
                          ? {
                              ...nominee,
                              nomineeEmail: nominee.nomineeEmailSameAsGuardian
                                ? e.target.value
                                : nominee.nomineeEmail,
                              guardianEmail: e.target.value,
                            }
                          : nominee;
                      }),
                    });
                  }}
                  disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.guardianPhone`}
                  label={`Guardian Phone Number`}
                  placeholder={`Enter Guardian Phone Number`}
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  startAdornment={
                    <CountryCodesDropDown
                      ElementWidth={mobileElementWidthGuardian && mobileElementWidthGuardian}
                      name={`nominees.${index}.guardianCountryNameAndCode`}
                      value={values.nominees[index].guardianCountryNameAndCode as string}
                      disabled={getDisableStatusForjointHolder(
                        role,
                        referenceDetail.applicant_type
                      )}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          nominees: values.nominees.map((nominee, _ind) => {
                            return _ind === index
                              ? {
                                  ...nominee,
                                  nomineeCountryNameAndCode: nominee.nomineePhoneSameAsGuardian
                                    ? e.target.value
                                    : nominee.nomineeCountryNameAndCode,
                                  guardianCountryNameAndCode: e.target.value,
                                }
                              : nominee;
                          }),
                        });
                      }}
                    />
                  }
                  onChange={(e) => {
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee, _nomineeInd) => {
                        return _nomineeInd === index
                          ? {
                              ...nominee,
                              nomineePhone: nominee.nomineePhoneSameAsGuardian
                                ? e.target.value
                                : nominee.nomineePhone,
                              guardianPhone: e.target.value,
                            }
                          : nominee;
                      }),
                    });
                  }}
                  disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                  regexForFilterValue={nonDigitRegex}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={6}>
            <TextDatePicker
              label={'Guardian Date of Birth *'}
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              placeholder={'Enter Guardian Date of Birth'}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              name={`nominees.${index}.guardianDOB`}
              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeGuardianPan`}
              label="Guardian PAN"
              placeholder="Enter Guardian Pan"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineeGuardianPan`, e.target.value.toUpperCase());
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`nominees.${index}.guardianRelationship`}
              label="Guardian Relationship *"
              items={Object.keys(NomineeRelations).map((relation) => ({
                key: NomineeRelations[relation],
                value: relation,
              }))}
              disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            />
          </Grid>
          {values.nominees.map((nominee, idx: number) => {
            if (
              NomineeRelations[nominee.guardianRelationship || ''] === NomineeRelations.others &&
              idx === index
            ) {
              return (
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`nominees.${index}.otherGuardianRelationship`}
                    label="Guardian Relationship *"
                    placeholder={`Enter Guardian Relationship`}
                    disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                  />
                </Grid>
              );
            }
          })}
          {/* <---------Guardian Address-------> */}
          <>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress1`}
                label={`Guardian Address Line 1 *`}
                placeholder="Enter Guardian Address Line 1"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress2`}
                label={`Guardian Address Line 2 *`}
                placeholder="Enter Guardian Address Line 2"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress3`}
                label={`Guardian Address Line 3 *`}
                placeholder="Enter Guardian Address Line 3"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianPincode`}
                label={`Guardian Pincode *`}
                placeholder="Enter Guardian Pincode"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianCity`}
                label={`Guardian City *`}
                placeholder="Enter Guardian City"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianState`}
                label={`Guardian State *`}
                placeholder="Enter Guardiane State"
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={`nominees.${index}.guardianCountry`}
                label="Guardian Country *"
                items={nationalitiesMdmsResponse.map((nationality) => ({
                  key: nationality.name,
                  value: nationality.name,
                }))}
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                searchFieldPlaceholder={'Search Country'}
              />
            </Grid>
          </>
        </>
      )}
    </>
  );
};

export default function NomineeDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  const [bulkNomineeDelete, setBulkNomineeDelete] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const [defaultAddress, setDefaultAddress] = useState<string>('');
  const [address, setAddress] = useState<any>();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);

  const [validationFlags, setValidationFlags] = useState<ValidationFlags>({
    showNomineIdType: false,
    removeDecimalValidationForPercentage: false,
  });

  const {
    nomineeWithDateValidation = '',
    nomineeRemoveDecimalValidationForNomineePercentage = '',
  } = useValidationOrConfigHook();

  const onSubmit = async (values: Values) => {
    try {
      const {
        nominees: existingNominees = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { nominees, doNotWishToNominate, saveType } = values;
      const updatedPayload = {
        ...application,
        doNotWishToNominate,
        nominees: nominees
          .filter((nominee) => nominee?.id || nominee.isActive)
          .map((nominee, index) => {
            const { id = null } = existingNominees[index] || {};
            if (nominee.id === id) {
              const { Relationship, otherGuardianRelationship, sno, ...rest } = nominee;
              return {
                ...(existingNominees[index] || {}),
                ...rest,
                nomineeIdType: validationFlags?.showNomineIdType
                  ? nominee?.nomineeIdType || ''
                  : '',
                nomineeIdTypeOther:
                  nomineeIdTypes[nominee?.nomineeIdType || ''] === nomineeIdTypes?.others
                    ? nominee?.nomineeIdTypeOther
                    : '',
                nomineeIdNumber: validationFlags?.showNomineIdType
                  ? nominee?.nomineeIdNumber || ''
                  : '',
                nomineeEmail: validationFlags?.showNomineIdType ? nominee?.nomineeEmail || '' : '',
                nomineePhone: validationFlags?.showNomineIdType ? nominee?.nomineePhone || '' : '',
                nomineeCountryCode: rest.nomineeCountryNameAndCode?.split(':')[1].trim(),
                nomineeRelationship: getNomineeRelation(Relationship)
                  ? Relationship
                  : removeSingleQuote(nominee.nomineeRelationship),
                dateOfBirth: !nominee.dateOfBirth
                  ? null
                  : new Date(nominee.dateOfBirth).toISOString(),
                isActive: nominee.isActive && !doNotWishToNominate,
                nomineeName: removeSingleQuote(rest.nomineeName),
                firstName: removeSingleQuote(rest.firstName),
                lastName: removeSingleQuote(rest.lastName),
                guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianName)
                  : null,
                guardianFirstName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianFirstName)
                  : null,
                guardianLastName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianLastName)
                  : null,
                guardianDOB: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? !rest.guardianDOB
                    ? null
                    : new Date(rest.guardianDOB).toISOString()
                  : null,
                nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.nomineeGuardianPan)
                  : null,
                guardianRelationship: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? getNomineeRelation(nominee.guardianRelationship)
                    ? nominee.guardianRelationship
                    : removeSingleQuote(otherGuardianRelationship)
                  : null,
                guardianAddress1: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress1)
                  : null,
                guardianAddress2: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress2)
                  : null,
                guardianAddress3: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress3)
                  : null,
                guardianPincode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianPincode)
                  : null,
                guardianCity: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianCity)
                  : null,
                guardianState: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianState)
                  : null,
                guardianCountry: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? rest.guardianCountry
                  : null,
                nomineePercentage:
                  nominee.nomineePercentage === 0 || nominee.nomineePercentage
                    ? Number(nominee.nomineePercentage)
                    : null,
                guardianPhone: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.guardianPhone
                  : null,
                guardianEmail: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.guardianEmail
                  : null,
                nomineePhoneSameAsGuardian: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.nomineePhoneSameAsGuardian
                  : newNominee.nomineePhoneSameAsGuardian,
                nomineeEmailSameAsGuardian: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.nomineeEmailSameAsGuardian
                  : newNominee.nomineeEmailSameAsGuardian,
                guardianCountryNameAndCode: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.guardianCountryNameAndCode
                  : 'India: +91',
                guardianCountryCode: isMinor(rest.dateOfBirth ? rest.dateOfBirth : '')
                  ? rest.guardianCountryNameAndCode?.split(':')[1].trim()
                  : '+91',
              };
            }
            const { Relationship, otherGuardianRelationship, sno, ...rest1 } =
              nominees[nominee.sno as number];
            return {
              ...rest1,
              nomineeIdType: rest1?.nomineeIdType || '',
              nomineeIdTypeOther:
                nomineeIdTypes[rest1?.nomineeIdType || ''] === nomineeIdTypes?.others
                  ? rest1?.nomineeIdTypeOther
                  : '',
              nomineeIdNumber: rest1?.nomineeIdNumber || '',
              nomineeEmail: rest1?.nomineeEmail || '',
              nomineePhone: rest1?.nomineePhone || '',
              nomineeCountryCode: rest1.nomineeCountryNameAndCode?.split(':')[1].trim(),
              nomineeRelationship: removeSingleQuote(rest1.nomineeRelationship),
              nomineeName: removeSingleQuote(rest1.nomineeName),
              firstName: removeSingleQuote(rest1.firstName),
              lastName: removeSingleQuote(rest1.lastName),
              guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianName)
                : null,
              guardianFirstName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianFirstName)
                : null,
              guardianLastName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianLastName)
                : null,
              guardianDOB: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? !rest1.guardianDOB
                  ? null
                  : new Date(rest1.guardianDOB).toISOString()
                : null,
              nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.nomineeGuardianPan)
                : null,
              guardianRelationship: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? getNomineeRelation(rest1.guardianRelationship)
                  ? rest1.guardianRelationship
                  : removeSingleQuote(otherGuardianRelationship)
                : null,
              guardianAddress1: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress1)
                : null,
              guardianAddress2: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress2)
                : null,
              guardianAddress3: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress3)
                : null,
              guardianPincode: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianPincode)
                : null,
              guardianCity: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianCity)
                : null,
              guardianState: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianState)
                : null,
              guardianCountry: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianCountry
                : null,
              guardianEmail: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianEmail
                : null,
              guardianPhone: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianPhone
                : null,
              nomineeEmailSameAsGuardian: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.nomineeEmailSameAsGuardian
                : newNominee.nomineeEmailSameAsGuardian,
              nomineePhoneSameAsGuardian: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.nomineePhoneSameAsGuardian
                : newNominee.nomineePhoneSameAsGuardian,
              guardianCountryNameAndCode: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianCountryNameAndCode
                : 'India: +91',
              guardianCountryCode: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianCountryNameAndCode?.split(':')[1].trim()
                : '+91',
            };
          }),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          nominees: application?.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
        },
        {
          ...updatedPayload,
          nominees: updatedPayload.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
          currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                checkInitialApplicationStatusIsChecker(application) &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 6,
              //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        !isSaveLater
          ? history.push('bank-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('bank-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };
  const [ModeOfHolding, SetModeOfHolding] = useState<boolean>(true);
  useEffect(() => {
    (async function () {
      try {
        const {
          nominees = [],
          doNotWishToNominate = true,
          modeOfHolding = '',
          applicants = [],
        } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const shouldShowNomineeIdTypes =
          !!nomineeWithDateValidation &&
          checkValidationBasedOnDate(application?.createdAt || '', nomineeWithDateValidation);
        const shouldAddwholeNumberValidation =
          !!nomineeRemoveDecimalValidationForNomineePercentage &&
          checkValidationBasedOnDate(
            application?.createdAt || '',
            nomineeRemoveDecimalValidationForNomineePercentage
          );
        setValidationFlags({
          ...validationFlags,
          showNomineIdType: shouldShowNomineeIdTypes,
          removeDecimalValidationForPercentage: shouldAddwholeNumberValidation,
        });
        const paramanantAddress = applicants
          .find((applicant) => applicant.applicant_type === '1')
          ?.addresses?.find((address) => address.address_type?.toLowerCase() === 'permanent');
        const address = `${checkAddressField(paramanantAddress?.address1)}${checkAddressField(
          paramanantAddress?.address2
        )}
    ${checkAddressField(paramanantAddress?.city)}${checkAddressField(
          paramanantAddress?.state
        )}${checkAddressField(paramanantAddress?.country)}${paramanantAddress?.pincode}`;
        setAddress(paramanantAddress);
        setDefaultAddress(address);
        SetModeOfHolding(modeOfHolding === 'single');
        setNomineesData({
          ...nomineesData,
          doNotWishToNominate:
            modeOfHolding === 'single'
              ? false
              : nominees.length
              ? false
              : doNotWishToNominate === null
              ? true
              : doNotWishToNominate,
          nominees: nominees.length
            ? nominees.map((nominee, index) => ({
                ...nominee,
                nomineeIdType: nominee?.nomineeIdType || '',
                nomineeIdTypeOther:
                  nomineeIdTypes[nominee?.nomineeIdType || ''] === nomineeIdTypes?.others
                    ? nominee?.nomineeIdTypeOther
                    : '',
                nomineeIdNumber: nominee?.nomineeIdNumber || '',
                nomineeEmail: nominee?.nomineeEmail || '',
                nomineePhone: nominee?.nomineePhone || '',
                nomineeCountryNameAndCode: nominee.nomineeCountryNameAndCode
                  ? nominee.nomineeCountryNameAndCode
                  : 'India: +91',
                Relationship: getNomineeRelation(nominee.nomineeRelationship?.toLowerCase())
                  ? nominee.nomineeRelationship
                    ? nominee.nomineeRelationship.toLowerCase()
                    : nominee.nomineeRelationship
                  : 'others',
                nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toLowerCase())
                  ? ''
                  : nominee.nomineeRelationship,
                nomineeCountry: nominee?.nomineeCountry?.toUpperCase() || '',
                guardianRelationship: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? getNomineeRelation(nominee.guardianRelationship?.toLowerCase())
                    ? nominee.guardianRelationship
                      ? nominee.guardianRelationship.toLowerCase()
                      : nominee.guardianRelationship
                    : 'others'
                  : null,
                otherGuardianRelationship: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? getNomineeRelation(nominee.guardianRelationship?.toLowerCase())
                    ? ''
                    : nominee.guardianRelationship
                  : null,
                guardianAddress1: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianAddress1
                    ? nominee.guardianAddress1
                    : ''
                  : null,
                guardianAddress2: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianAddress2
                    ? nominee.guardianAddress2
                    : ''
                  : null,
                guardianAddress3: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianAddress3
                    ? nominee.guardianAddress3
                    : ''
                  : null,
                guardianCity: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianCity
                    ? nominee.guardianCity
                    : ''
                  : null,
                guardianState: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianState
                    ? nominee.guardianState
                    : ''
                  : null,
                guardianCountry: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianCountry
                    ? nominee.guardianCountry?.toUpperCase()
                    : ''
                  : null,
                guardianPincode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? nominee.guardianPincode
                    ? nominee.guardianPincode
                    : ''
                  : null,
                sno: index,
                nomineePercentage: nominee.nomineePercentage
                  ? nominee.nomineePercentage
                  : nominees.length === 1
                  ? 100
                  : 0,
              }))
            : modeOfHolding === 'single'
            ? [
                {
                  ...newNominee,
                  nomineePercentage: 100,
                  nomineeAddress1: checkAddressField(paramanantAddress?.address1),
                  nomineeAddress2: checkAddressField(paramanantAddress?.address2),
                  nomineeAddress3: checkAddressField(paramanantAddress?.address3),
                  nomineeCity: paramanantAddress?.city,
                  nomineeState: paramanantAddress?.state,
                  nomineeCountry: paramanantAddress?.country?.toUpperCase(),
                  nomineePincode: paramanantAddress?.pincode,
                  guardianAddress1: checkAddressField(paramanantAddress?.address1),
                  guardianAddress2: checkAddressField(paramanantAddress?.address2),
                  guardianAddress3: checkAddressField(paramanantAddress?.address3),
                  guardianCity: paramanantAddress?.city,
                  guardianState: paramanantAddress?.state,
                  guardianCountry: paramanantAddress?.country?.toUpperCase(),
                  guardianPincode: paramanantAddress?.pincode,
                },
              ]
            : [],
          countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application, nomineeWithDateValidation]);

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            nomineeDetailsSchema(
              application?.applicants,
              validationFlags.showNomineIdType,
              validationFlags?.removeDecimalValidationForPercentage
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues, errors }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes displayContent={'Investor(s) have the option to choose upto three nominees'} />
          <Grid item xs={12}>
            <MFCheckbox
              // disabled={ModeOfHolding}
              name="doNotWishToNominate"
              label="I do not wish to nominate."
              sx={{ letterSpacing: '1px' }}
              onChange={({ target: { checked } }) => {
                const updatedNominees = !checked
                  ? [
                      ...values.nominees,
                      {
                        ...newNominee,
                        nomineePercentage: 100,
                        sno: values.nominees.length,
                        nomineeAddress1: checkAddressField(address?.address1),
                        nomineeAddress2: checkAddressField(address?.address2),
                        nomineeAddress3: checkAddressField(address?.address3),
                        nomineeCity: address?.city,
                        nomineeState: address?.state,
                        nomineeCountry: address?.country?.toUpperCase(),
                        nomineePincode: address?.pincode,
                        guardianAddress1: checkAddressField(address?.address1),
                        guardianAddress2: checkAddressField(address?.address2),
                        guardianAddress3: checkAddressField(address?.address3),
                        guardianCity: address?.city,
                        guardianState: address?.state,
                        guardianCountry: address?.country?.toUpperCase(),
                        guardianPincode: address?.pincode,
                        guardianCountryNameAndCode: 'India: +91',
                      },
                    ]
                  : values.nominees;
                setValues({
                  ...nomineesData,
                  doNotWishToNominate:
                    values.nominees?.filter((item) => item.isActive).length === 0
                      ? checked
                      : !checked,
                  nominees: updatedNominees.map((nominee) => ({
                    ...nominee,
                  })),
                });
                checked && setBulkNomineeDelete(true);
              }}
              checked={values.doNotWishToNominate}
              disabled={
                ModeOfHolding ||
                getDisableStatusForjointHolder(role, referenceDetail.applicant_type)
              }
            />
          </Grid>
          {values.nominees
            .filter((_nominee) => _nominee.isActive)
            .map((nominee, index) => (
              <React.Fragment key={index}>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }}>
                  {getApplicantName(index + 1, true)} Nominee Details
                  {((ModeOfHolding &&
                    values.nominees.filter((nominee) => nominee.isActive).length !== 1) ||
                    !ModeOfHolding) && (
                    <Box
                      aria-label="Remove Nominee"
                      role="button"
                      sx={{ display: 'flex', alignItems: 'center' }}
                      onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}>
                      <Typography
                        component="span"
                        sx={{
                          color: '#E50000',
                          fontSize: 12,
                          ml: 'auto',
                          letterSpacing: '-0.2px',
                          cursor: 'pointer',
                        }}>
                        Remove Nominee{' '}
                      </Typography>
                      <IconButton component="span" sx={{ p: '2px' }}>
                        <CardMedia
                          component="img"
                          sx={{
                            width: 'unset',
                            filter:
                              'invert(12%) sepia(97%) saturate(6000%) hue-rotate(358deg) brightness(90%) contrast(110%)',
                          }}
                          src="/images/delete-red.svg"
                          alt="Delete Icon"
                        />
                      </IconButton>
                    </Box>
                  )}
                </SubHeading>
                <Nominee
                  nomineeName={index + 1}
                  index={nominee.sno as number}
                  key={nominee.sno as number}
                  values={values}
                  nationalitiesMdmsResponse={mdmsCountriesList}
                  address={address}
                  shouldShowNomineeIdTypes={validationFlags.showNomineIdType}
                />
              </React.Fragment>
            ))}
          {values.nominees.filter((item) => item.isActive).length < 10 && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mt: 2,
                }}
                disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
                onClick={() =>
                  setValues({
                    ...values,
                    nominees: [
                      ...values.nominees,
                      {
                        ...newNominee,
                        nomineePercentage: values.nominees.filter((item) => item.isActive).length
                          ? 0
                          : 100,
                        sno: values.nominees.length,
                        nomineeAddress1: checkAddressField(address?.address1),
                        nomineeAddress2: checkAddressField(address?.address2),
                        nomineeAddress3: checkAddressField(address?.address3),
                        nomineeCity: address?.city,
                        nomineeState: address?.state,
                        nomineeCountry: address?.country?.toUpperCase(),
                        nomineePincode: address?.pincode,
                        guardianAddress1: checkAddressField(address?.address1),
                        guardianAddress2: checkAddressField(address?.address2),
                        guardianAddress3: checkAddressField(address?.address3),
                        guardianCity: address?.city,
                        guardianState: address?.state,
                        guardianCountry: address?.country?.toUpperCase(),
                        guardianPincode: address?.pincode,
                      },
                    ],
                    doNotWishToNominate: false,
                  })
                }>
                Add Nominee
              </Button>
            </Grid>
          )}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship:
                    NomineeRelations[nominee?.Relationship || ''] === NomineeRelations.others
                      ? nominee.nomineeRelationship
                      : nominee.Relationship,
                })),
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship:
                    NomineeRelations[nominee?.Relationship || ''] === NomineeRelations.others
                      ? nominee.nomineeRelationship
                      : nominee?.Relationship,
                })),
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={'Are you sure you want to delete nominees ?'}
            open={nomineeToDelete !== null || bulkNomineeDelete !== false}
            setOpen={() => {
              setBulkNomineeDelete(false);
              setNomineeToDelete(null);
            }}
            onSave={async () => {
              try {
                const { id } = application || {};
                const remainedApplicants = values.nominees.map((nominee, i) => {
                  if (nominee.sno === nomineeToDelete?.index || bulkNomineeDelete) {
                    return {
                      ...nominee,
                      isActive: false,
                    };
                  }
                  return nominee;
                });
                setValues({
                  ...values,
                  nominees: remainedApplicants,
                  doNotWishToNominate:
                    remainedApplicants.filter((item) => item.isActive).length === 0
                      ? true
                      : values.doNotWishToNominate,
                });
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              } catch (e) {
                console.error((e as Error).message);
              }
            }}
            onCancel={() => {
              setBulkNomineeDelete(false);
              setNomineeToDelete(null);
            }}
          />
        </Grid>
      )}
    </Formik>
  );
}
